import script from "./DetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsView.vue?vue&type=script&setup=true&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=8bb604c6&lang=css"

const __exports__ = script;

export default __exports__